<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "new",
  created() {
    localStorage.setItem('loginState',1)
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/new.vue